import { render, staticRenderFns } from "./GeneralLayout.vue?vue&type=template&id=9f9bd2b6&"
import script from "./GeneralLayout.vue?vue&type=script&lang=ts&"
export * from "./GeneralLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports